import styled, { css } from "styled-components";
import { PropsWithPropStyling, propStyling, tombac } from "../../../shared";
import { ToggleGroupSize } from "../ToggleGroupRoot";

type GroupContainerProps = PropsWithPropStyling<{
  disabled?: boolean;
  isFocusVisible: boolean;
  isInvalid: boolean;
  size?: ToggleGroupSize;
}>;

const sizeStyles = tombac.variant<GroupContainerProps>("size", {
  m: css<GroupContainerProps>`
    height: ${tombac.space(5)};
  `,
  s: css<GroupContainerProps>`
    height: ${tombac.space(4)};
  `,
  xs: css<GroupContainerProps>`
    height: ${tombac.space(3.5)};
  `,
});

export const GroupContainer = styled.div<GroupContainerProps>`
  all: initial;

  ${({
    theme: {
      components: {
        toggleGroup: { current: { root } = {} },
      },
    },
  }) => css<GroupContainerProps>`
    ${({ disabled }) =>
      tombac.text({
        color: disabled ? tombac.alpha("neutral", 24) : undefined,
      })}

    border: ${tombac.unit(1)} solid ${({
      disabled,
      isFocusVisible,
      isInvalid,
    }) =>
      !disabled && isFocusVisible
        ? tombac.parse(root!.focusVisible!.borderColor)
        : isInvalid
        ? tombac.parse(root!.invalid!.borderColor)
        : tombac.parse(root!.borderColor)};
    border-radius: 999rem;
    box-sizing: border-box;
    display: flex;
    height: ${tombac.space(5)};
    margin: 0;
    width: max-content;
    padding: ${tombac.unit(2, 1)};
    transition: border-color 0.1s ease-out;
  `}
  ${sizeStyles}
  ${propStyling}
`;
